import { render, staticRenderFns } from "./RequestFeatureCard.vue?vue&type=template&id=4c5ba293&scoped=true&"
import script from "./RequestFeatureCard.vue?vue&type=script&lang=js&"
export * from "./RequestFeatureCard.vue?vue&type=script&lang=js&"
import style0 from "./RequestFeatureCard.vue?vue&type=style&index=0&id=4c5ba293&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5ba293",
  null
  
)

export default component.exports